import { ApolloCache } from '@apollo/client';
import { invalidateApolloCacheFor } from 'core/apollo-cache-invalidator';

export const invalidateDuplicatesCache = (cache: ApolloCache<any>, entityId: string, campaignId: string) => {
  invalidateApolloCacheFor(
    cache, ({ fieldName, args }) =>
    fieldName?.includes('getPotentialEntityDuplicates') && args?.entityId === entityId && args?.campaignId === campaignId
  );
};


